<div class="day">
  <div>{{date | JsDate}}</div>
</div>
